import React from 'react'
import Python from '../Components/Python/Python'
import Python1 from '../Components/Python1/Python1'
import Pythoncurriculum from '../Components/Pythoncurriculum/Pythoncurriculum';
import Watermark from '../Components/Watermark/Watermark';
const Pythonpage = () => {
  return (
    <div>
      <Watermark/>
      <Python/>
      <Python1/>
      <Pythoncurriculum/>
    </div>
  )
}

export default Pythonpage
